import { IGeneralLang } from '../../../types/lang'

export const generalLang: IGeneralLang = {
	general: {
		btn_filters_apply: 'Применить',
		react_select_placeholder: 'Выберите...',
		react_select_no_options: 'Опции отсутствуют',
		react_select_create_label: 'Создать',
		header_language_label: 'Язык',
		total_label: 'Всего',
		table_no_data: 'Данные отсутствуют'
	}
}